export enum HEADER_SEARCH_TOOLTIP {
  TITLE = 'Vind snel wat je wilt kijken',
  DESCRIPTION = 'Gebruik onze zoekfunctie om je favoriete programma’s en clips te vinden',
  BUTTON_TEXT = 'Ok, ik snap het!'
}
